import { Checkbox as SemanticCheckbox } from 'semantic-ui-react';
import styled from 'styled-components';

const Ranges = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-left: 25px;
  padding-right: 25px;
  color: #192C47;

  div {
    display: flex;
    flex-direction: column;

    span {
      font-size: 14px;
      margin-top: 5px;
    }
  }
`;

const Checkbox = styled(SemanticCheckbox)`
  &&& {
    margin: 0 0 1em;
  }
  &.ui.checkbox input.hidden+label {
    color: #192C47;
    opacity: 1;
  }
`;

const RangeRadioContainer = styled.div`
  cursor: pointer;
  padding: 4px 0;
`;

const Difficulty = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 4px;
  margin-bottom: 5px;
`;

const Label = styled.span`
  font-size: 14px;
  color: #192C47;
`;

export {
  Difficulty,
  RangeRadioContainer,
  Ranges,
  Label,
  Checkbox,
};
